import { ModeBadge } from '@src/entities/ActionPath/ui/components/misc/ModeBadge';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { ActionNav } from '@uhg-abyss/web/ui/ActionNav';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Indicator } from '@uhg-abyss/web/ui/Indicator';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { isEmpty } from 'lodash';
import React, { useEffect } from 'react';

import { useWizardContext } from '../../../../context';
import { isValidStep } from '../../../../includes/functions';
import { NameField } from '../../../fields/Name';
import { Styles } from './includes/styles';

/**
 * Header
 *
 * Displays the total number of steps, the current step, and allows the user to input the action path name.
 *
 * @param form
 * @returns {Element}
 * @constructor
 */
export function Header({ form = {} }) {
  const wizardContext = useWizardContext();

  const { actionPath, currentStep, isManual, previousStep, steps } = wizardContext;

  const validName = !!isEmpty(form?.formState?.errors?.name);
  const isCurrentStepValid = isValidStep(currentStep, validName, form?.formState?.errors, isManual);

  /**
   * Highlights each current/completed step.
   */
  useEffect(() => {
    const navigationItems = document.querySelectorAll('.abyss-action-nav-list-item');

    if (navigationItems instanceof NodeList && !isEmpty(navigationItems)) {
      navigationItems.forEach((navigationItem, index) => {
        const classes = navigationItem.classList;
        classes.remove('current', 'completed');

        if (currentStep?.order - 1 === index && !classes.contains('current')) {
          classes.add('current');
        }

        if (currentStep?.order - 1 > index && !classes.contains('completed')) {
          classes.add('completed');
        }
      });
    }
  }, [currentStep, steps, isCurrentStepValid]);

  return (
    <ErrorHandler location="src/features/ActionPaths/Wizard/components/misc/Layout/Header/Header.jsx">
      <Styles>
        <Grid>
          <Grid.Col>
            <Heading offset={0}>
              <Layout.Group>
                <div>
                  <span className="capitalize">{wizardContext?.action}</span> Action Path
                </div>
                <div>
                  <ModeBadge mode={wizardContext?.mode} />
                </div>
              </Layout.Group>
            </Heading>
          </Grid.Col>
          <Grid.Col
            span={{
              xs: '100%',
            }}
          >
            <ActionNav subText={<NameField actionPath={actionPath} form={form} />} title="Action Path">
              {steps?.map((step, index) => {
                return (
                  <ActionNav.Item
                    actionText={
                      <Flex alignItems="center" direction="row" justify="right">
                        <Indicator
                          label={index + 1}
                          offset={-1}
                          position="top-start"
                          showZero={false}
                          size="small"
                          withBorder
                        />
                        <div>{step?.label}</div>
                      </Flex>
                    }
                    hideIcon
                    href=""
                    key={`${steps[index]?.key}`}
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                    }}
                    title=""
                    variant={currentStep?.order > previousStep?.order ? 'success' : 'info'}
                  />
                );
              })}
            </ActionNav>
          </Grid.Col>
        </Grid>
      </Styles>
    </ErrorHandler>
  );
}
